/** Shared styles for HTML problem statements (description / constraints). */
export const problemStatementSx = (isDark) => ({
  mb: 1,
  fontSize: '15px',
  lineHeight: 1.55,
  whiteSpace: 'pre-wrap',
  color: 'text.primary',
  '& pre': {
    bgcolor: isDark ? '#0d1117' : '#f6f8fa',
    p: 1.25,
    borderRadius: 1.5,
    overflow: 'auto',
  },
  '& code': {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    fontSize: '0.88em',
  },
  '& .ch-problem-visual': {
    display: 'block',
    margin: '1rem 0 1.15rem',
    padding: '0.9rem 1rem 0.75rem',
    borderRadius: '12px',
    border: isDark ? '1px solid #30363d' : '1px solid rgba(19,114,116,0.2)',
    background: isDark
      ? 'linear-gradient(180deg, rgba(19,114,116,0.18) 0%, #161b22 65%)'
      : 'linear-gradient(180deg, #eef7f8 0%, #ffffff 70%)',
    overflow: 'hidden',
  },
  '& .ch-problem-visual svg': {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    margin: '0 auto',
  },
  '& .ch-problem-visual figcaption': {
    display: 'block',
    marginTop: '0.65rem',
    fontSize: '0.8rem',
    lineHeight: 1.45,
    color: isDark ? '#8b949e' : '#5f6b73',
    whiteSpace: 'normal',
  },
  '& figure': {
    margin: 0,
  },
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '8px',
  },
});

export default problemStatementSx;
